import userIcon from '../../../assets/doctor.png'
import profileIcon from '../../../assets/profile.svg'
import docIcon from '../../../assets/doc.png'
import calIcon from '../../../assets/cal.svg'
import { Col } from 'react-bootstrap'

export default function ProfileDrawer({ clinicianProfile, show, setShow, editLicense, isAddLicenceWip, isPersonInfoWip, handleSnackOpen }) {
  return (
    <>
      {/* //$ Left Side View */}
      <p
        style={{
          fontSize: 60,
          lineHeight: '100%',
          color: 'rgba(0, 127, 97, 1)',
          textTransform: 'capitalize',
          fontFamily: 'GT Super Display',
          fontWeight: '500',
        }}
      >
        My Profile
      </p>
      <div style={{ width: '80%', height: '100%', borderRadius: 25, background: 'rgba(0, 127, 97, 1)' }}>
        {/* Avatar Image */}
        <div style={centerThis}>
          <div
            className="mt-5"
            style={{
              width: 150,
              height: 150,
              borderRadius: 500,
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <img
              style={{
                left: 0,
                top: 0,
                position: 'absolute',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
              src={userIcon}
              alt="Avatar"
            />
          </div>
        </div>
        <div
          style={{
            fontSize: 24,
            fontWeight: '600',
            letterSpacing: 2,
            lineHeight: '116.70%',
            color: 'rgba(253, 250, 241, 1)',
            marginTop: 15,
          }}
        >
          {`${clinicianProfile?.firstName} ${clinicianProfile?.lastName}`}
        </div>

        <p
          style={{
            textAlign: 'center',
            fontSize: 18,
            color: 'rgba(253, 250, 241, 0.50)',
          }}
        >
          {clinicianProfile?.tbdEmail || 'unknown TBD email'}
        </p>
        <Col style={centerThis}>
          <div style={{ textAlign: 'center', width: 155, height: 60 }}>
            <p
              style={{
                cursor: 'pointer',
                fontSize: 18,
                fontWeight: '500',
                lineHeight: '116.70%',
                color: 'rgba(253, 250, 241, 1)',
              }}
            >
              Fun fact about me&nbsp;&nbsp;&nbsp;
              {/* <img src={editIcon} alt="change fun fact" /> */}
            </p>
            <p
              style={{
                fontSize: 16,
                fontWeight: '600',
                lineHeight: '50%',
                color: 'rgba(253, 250, 241, 1)',
              }}
            >
              {clinicianProfile?.funFact || '-'}
            </p>
          </div>
        </Col>
        <div
          style={{
            paddingLeft: 15,
            height: 162,
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
        >
          <div style={{ height: 4.67 }} />
          <div
            style={{
              cursor: 'pointer',
              opacity: show === 2 ? 1 : 0.6,
              width: 'auto',
              fontSize: 24,
              fontWeight: show === 2 ? 'bold' : 'normal',
              lineHeight: '150%',
              color: 'rgba(253, 250, 241, 1)',
              textAlign: 'left',
            }}
            onClick={() => {
              if (editLicense === true || isAddLicenceWip === true) {
                handleSnackOpen('Update or discard changes.', 'error')
                return
              }
              setShow(2)
            }}
          >
            <img alt="icon" src={profileIcon} style={{ height: 22, filter: 'invert(1)', objectFit: 'contain' }} />
            &nbsp;&nbsp;&nbsp;Personal Information
          </div>
          <div style={{ height: 4.67 }} />
          <div
            style={{
              cursor: 'pointer',
              width: 'auto',
              fontSize: 24,
              fontWeight: show === 3 ? 'bold' : 'normal',
              opacity: show === 3 ? 1 : 0.6,
              lineHeight: '150%',
              color: 'rgba(253, 250, 241, 1)',
              textAlign: 'left',
            }}
            onClick={() => {
              if (isPersonInfoWip === true) {
                handleSnackOpen('Update or discard changes.', 'error')
                return
              }
              setShow(3)
            }}
          >
            <img alt="icon" src={docIcon} style={{ height: 22, filter: 'invert(1)', objectFit: 'contain' }} />
            &nbsp;&nbsp;&nbsp;Manage Licences
          </div>
          <div style={{ height: 4.67 }} />
          <div
            style={{
              cursor: 'pointer',
              width: 'auto',
              fontSize: 24,
              fontWeight: show === 4 ? 'bold' : 'normal',
              opacity: show === 4 ? 1 : 0.6,
              lineHeight: '150%',
              color: 'rgba(253, 250, 241, 1)',
              textAlign: 'left',
            }}
            onClick={() => setShow(4)}
          >
            <img alt="icon" src={calIcon} style={{ height: 22, filter: 'invert(1)', objectFit: 'contain' }} />
            &nbsp;&nbsp;&nbsp;Manage Calendar
          </div>
          <div
            style={{
              cursor: 'pointer',
              width: 'auto',
              fontSize: 24,
              fontWeight: show === 5 ? 'bold' : 'normal',
              opacity: show === 5 ? 1 : 0.6,
              lineHeight: '150%',
              color: 'rgba(253, 250, 241, 1)',
              textAlign: 'left',
            }}
            onClick={() => {
              if (isPersonInfoWip === true) {
                handleSnackOpen('Update or discard changes.', 'error')
                return
              }
              setShow(5)
            }}
          >
            <img alt="icon" src={docIcon} style={{ height: 22, filter: 'invert(1)', objectFit: 'contain' }} />
            &nbsp;&nbsp;&nbsp;Manage Templates
          </div>
        </div>
      </div>
    </>
  )
}

const centerThis = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}
